import type { EvidenceRequirementStatus } from "../services/evidence_requirements.service";
import { browserCalendarToday, calendarDueState } from "./assessment_task_date.util";
import type { CalendarDueState } from "./assessment_task_date.util";

export function evidenceRequirementDueState(
    dueDate: string | null,
    status: EvidenceRequirementStatus,
    today: string | null = browserCalendarToday()
): CalendarDueState {
    return calendarDueState(dueDate, status === "submitted_reviewed", today);
}
